import axios from 'axios';
import { round, } from 'lodash';
import moment from 'moment/moment';
import React, { useRef } from 'react'
import { useMemo } from 'react';
import { useCallback } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Label, Button } from 'reactstrap';
import EmptyTable from '../../../../components/errorComponents/EmptyTable';
import ErrorComponents from '../../../../components/errorComponents/ErrorComponents';
import SuccessPopups from '../../../../components/Popups/SuccessPopups';
import WarningPopup from '../../../../components/Popups/WarningPopup';
import Table from '../../../../components/Table';
import { environment } from '../../../../env';
import { getBuildingAction, linkRedirectAction, loaderAction, successInfoAction, successModalToggle, warningModalToggle } from '../../../../redux/actions/Index';
import { ToWords } from 'to-words';
import PriceFormater from './../../../../Helper/PriceFormater';
import Docm from '../../../../components/DocumentsCard/Docm';
import ErrorPopups from '../../../../components/Popups/ErrorPopups';
import { Phone } from 'react-telephone';
import { PencilLine, Trash } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import 'url-change-event'
import { ArrowSquareLeft, ArrowSquareRight } from 'iconsax-react';
import { toast } from 'react-toastify';

const DraftedProposal = () => {

  const [ID, setID] = useState()
  const [edit, setEdit] = useState(false)
  const [pinerror, setPinerror] = useState();
  const [intentdata, setIntentData] = useState();
  const [contactNumber, setContactNumber] = useState();
  const [filterBuilding, setFilterBuilding] = useState([]);
  const [createe, setCreate] = useState(false)
  const [btndis, setBtndis] = useState(false)
  const [verify, setVerify] = useState(false)
  const [open, setOpen] = useState(false)
  const [isInvestorArrayDirty, setIsInvestorArrayDirty] = useState(false);
  const [formDataLossToggle, setFormDataLossToggle] = useState(false);
  const [formForceRerender, setFormForceRerender] = useState(true);
  const [investors, setInvestors] = useState()
  const [totalerr, setTotalerr] = useState()
  const [totalArea, setTotalArea] = useState(0)
  const [letterToggle, setLetterToggle] = useState()
  const [carpeterror, setCarpetErrorMessage] = useState("")
  const [area, setArea] = useState([])
  const [tempDraftInvestor, setTempDraftInvestor] = useState([]);
  const [err, setErr] = useState("");
  const [proposal, setProposal] = useState()
  const [proposalStatus, setproposalStatus] = useState([])
  const [proposalinvestors, setProposalInvestors] = useState()
  const [panerror, setPanError] = useState('');
  const [tenant, setTenant] = useState()
  const [availCheck, setAvailCheck] = useState(false)
  const preventNegativeValues = (e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
  const preventNegativeValuesspi = (e) => ["+", "-", "!", "@", "#", "$", "%", "^", "&", "*", "=", "/", "_"].includes(e.key) && e.preventDefault()
  const [invesarr, setinvesarr] = useState([])
  const [buildingtype, setBuildingType] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [records, setRecords] = useState(10);
  const [nextIsValid, setNextIsValid] = useState(false);
  const [prevIsValid, setPrevIsValid] = useState(false);
  const cityList = useSelector((state) => state?.ModalReducer?.cityList);
  var aray = []
  const toWords = new ToWords();
  const dispatch = useDispatch();
  const navigate = useNavigate();


  const {
    register,
    handleSubmit,
    reset,
    watch,
    control,
    setValue,
    getValues,
    clearErrors,
    formState: { errors, isDirty },
  } = useForm({ mode: "onChange" });

  // const selproject = watch("project")
  const selbuilding = watch("building_no")
  const requiredarea = watch("required_area")
  var rentPrice = watch("rent_price")
  var varai = watch("varai")
  var maintenance = watch("maintenance")
  var pann = watch("pan_no")
  var rentalsqft = watch("rentalsqft")
  var extra_amenities = watch("extra_amenities")
  var other_charges = watch("other_charges")
  const totalPrice = (Number(rentPrice) + Number(varai) + Number(maintenance) + Number(extra_amenities) + Number(other_charges))

  const projectList = useSelector((state) => state?.ModalReducer?.projectList);
  const buildingList = useSelector((state) => state?.ModalReducer?.buildingList);
  const constitutionlist = useSelector((state) => state?.ModalReducer?.constitutionList);
  const watersupply = useSelector((state) => state?.ModalReducer?.watersupply);
  const userProject = useSelector((state) => state?.ModalReducer?.userproject);
  const user = useSelector((state) => state?.Reducers?.userdata);


  // const getProposals = async (data) => {
  //   dispatch(loaderAction(true))
  //   try {
  //     await axios.get(`${environment.baseUrl}temp-proposal/`).then((proposal) => {
  //       let dataa = proposal.data.filter((data) => data.project.id == userProject)
  //       setProposal(dataa);
  //       setproposalStatus(dataa);
  //       dispatch(loaderAction(false))
  //     })
  //   }
  //   catch (err) {
  //     dispatch(loaderAction(false))
  //     console.log(err);
  //   }
  // }

  const checkGst = (data) => {
    let flag = false
    if (data.length > 0) {
      if (pann != undefined && data.length == 15) {
        for (let i = 2; i < 12; i++) {
          if (data[i].toUpperCase() != pann[i - 2].toUpperCase()) {
            flag = true
          }
        }
      } else {
        flag = true
      }
    } else if (data.length == 0) {
      flag = false
    }


    if (flag == true) {
      setPanError('Please Enter Correct GST Number')
      setBtndis(false)
    } else {
      setPanError('')
      setBtndis(true)
    }
  }

  const getDraftProposalInvestors = async (id) => {
    dispatch(loaderAction(true))
    setFormForceRerender(false);
    try {
      await axios.get(`${environment.baseUrl}edit-temp-proposal/${id}`).then((response) => {
        setProposalInvestors(response.data);
        setID(id);
        getDraftInvestorTable(id);
        editForm(response.data);
        if (response.data.contact_number != "contact_number") {
          setContactNumber(response.data.contact_number);
        }
        setFormForceRerender(true);
        dispatch(loaderAction(false))
      })
    }
    catch (err) {
      dispatch(loaderAction(false))
      console.log(err);
    }
  }

  const getDraftInvestorTable = async (id) => {
    setFormForceRerender(false);
    try {
      await axios.get(`${environment.baseUrl}edit-temp-proposal-inv/${id}`).then((response) => {
        setTempDraftInvestor(response.data);
        let a = 0
        response.data.map(data => a = Number(data.required_area) + Number(a))
        setTotalArea(a)
        setFormForceRerender(true);
      })
    }
    catch (err) {
      console.log(err);
    }
  }

  useMemo(() => {
    let a = 0
    let b = []
    tempDraftInvestor.map(data => {
      a = Number(a) + Number(data.required_area)
      b.push({ "id": data.investor.id, "required_area": data.required_area, "check": true, "avail": (data.investor.sold_gala_area) - (data.investor.rent_area) - (data.investor.resell_area) });
    })
    setinvesarr(b);
    setTotalArea(a);
  }, [tempDraftInvestor])

  const debounce = useCallback(
    _.debounce((_searchVal) => {
      if (_searchVal.length > 6 || _searchVal.length < 6) {
        setPinerror("Pincode needs to be 6 digits")
        setBtndis(true)
        if (_searchVal == "") {
          setPinerror()
          setBtndis(false)
        }
      }
      else {
        setBtndis(false)
        setPinerror()
      }
    }, 600),
    []
  );

  const GetIntentData = () => {
    try {
      axios.get(`${environment.baseUrl}addloi`).then((res) => {

        setIntentData(res.data[0])
        var indata = res.data[0]
        reset({
          "lessor_name": `${indata?.lessor_name}`,
          "lessor_address": `${indata?.lessor_address}`,
          "facility_location": `${indata?.facility_location}`,
          "taxes": `${indata?.taxes}`,
          "refundable_security": `${indata?.refundable_security}`,
          "tenure": `${indata?.tenure}`,
          "lock_in_period": `${indata?.lock_in_period}`,
          "notice_period": `${indata?.notice_period}`,
          "stamp_duty": `${indata?.stamp_duty}`,
          "payment_terms": `${indata?.payment_terms}`,
          "licenses_approval": `${indata?.licenses_approval}`,
          "escalation_maintenance": `${indata?.escalation_maintenance}`,
          "parking_area": `${indata?.parking_area}`,
          "water_connection": `${indata?.water_connection}`,
          "electricity_charges": `${indata?.electricity_charges}`,
          "representation_lessor": `${indata?.representation}`,
          "additional_comments": `${indata?.additional_comments}`,
          "possession_date": moment(new Date()).format('YYYY-MM-DD'),
        })
      })
    }
    catch (err) {
      dispatch(loaderAction(false))
      console.log(err);
    }
  }

  const getTenant = async () => {
    dispatch(loaderAction(true))
    await axios.get(`${environment.baseUrl}add-gala-tenant/`).then((res) => {
      setTenant(res.data)
    })
  }

  const getInvestors = async (projectid, buildingid) => {
    dispatch(loaderAction(true))
    const payload = new FormData();
    payload.append("project", projectid)
    payload.append("building", buildingid)
    try {
      await axios.post(`${environment.baseUrl}sold-gala-investors/`, payload).then((investors) => {
        // setInvestors(investors.data.data);
        investors.data.data.map((data) => {
          if (!(data.sold_gala_area == data.resell_area))
            aray.push(data)
        })
        setInvestors(aray)
        dispatch(loaderAction(false))
      })
    }
    catch (err) {
      dispatch(loaderAction(false))
      console.log(err);
    }
  }

  useMemo(() => {
    GetIntentData()
  }, [createe])

  useMemo(async () => {
    if (userProject && selbuilding) {
      await getInvestors(userProject, selbuilding);
      let total = 0
      aray.map((investor) => {
        total = Number(total) + Number(Number(investor.sold_gala_area) - Number(investor.rent_area) - Number(investor.resell_area))
      })
      setArea(round(total, 2));
    }
    investors?.length == 0 && setTotalArea(0);
    // tempDraftInvestor.length == 0 && setTotalArea(0);
  }, [selbuilding])

  const restData = () => {
    setTempDraftInvestor([]);
    setTotalArea(0);
  }

  useMemo(() => {
    if (Number(requiredarea) > Number(area)) {

      setCarpetErrorMessage(`${requiredarea} is greater than Available area ${area} in selected Building`)
    } else {
      setCarpetErrorMessage("");
    }
  }, [requiredarea, rentalsqft]);

  const AddProposal = async (data) => {
    data.rent_sqft = Number(rentPrice) + Number(varai) + Number(maintenance) + Number(extra_amenities) + Number(other_charges)
    data.other_charges == '' ? data.other_charges = 0.0 : '';
    data.rentalsqft == undefined ? ' ' : data.rentalsqft
    if (data.required_area === "" || data.required_area == 0) {
      data.required_area = 0.0;
    }
    if (data.rent_price === "") {
      data.rent_price = 0.0;
    }
    if (data.varai === "") {
      data.varai = 0.0;
    }
    if (data.extra_amenities === "") {
      data.extra_amenities = 0.0;
    }
    if (data.maintenance === "") {
      data.maintenance = 0.0;
    }
    if (data.contact_number === "") {
      data.contact_number = "contact_number"
    }
    if (data.register_address === "") {
      data.register_address = "register_address"
    }
    if (data.tenant_deposit_amount === "") {
      data.tenant_deposit_amount = 0.0;
    }
    var status = data.status;
    data.investor = invesarr;
    data.create = 'false';
    data.project = userProject;
    dispatch(loaderAction(true))
    setBtndis(true)
    if (edit == false) {
      if (totalArea > 0) {
        data.tempId = ID;
        try {
          await axios.post(`${environment.baseUrl}proposal/`, data).then((form) => {
            if (form.data.code === 200) {
              dispatch(successModalToggle());
              setCreate(false);
              setinvesarr([]);
              setProposalInvestors()
              dispatch(loaderAction(false));
              // getProposals();
              filterApiCall();
              setBtndis(false);
              reset();
            }
            else {
              setBtndis(false);
            }
          })
        }
        catch (err) {
          dispatch(loaderAction(false))
          console.log(err);
          setBtndis(false);
        }
      } else {
        setOpen(true)
        setBtndis(false);
      }
    } else {
      try {
        if ((status == 'Approved' && availCheck) ? false : true) {
          await axios
            .put(`${environment.baseUrl}edit-proposal/${ID}`, data)
            .then((form) => {
              if (form.data.code === 200) {
                if (status == "Approved") {
                  dispatch(linkRedirectAction('/TenantGala'))
                  dispatch(successInfoAction("LOI Approved,Please Create Aggrement now"))
                } else {
                  dispatch(linkRedirectAction())
                  dispatch(successInfoAction())
                }
                setCreate(false);
                dispatch(loaderAction(true));
                dispatch(successModalToggle());
                // getProposals();
                filterApiCall();
                setProposalInvestors();
                setBtndis(false);
                setinvesarr([]);
                reset({
                  "building_no": "",
                  "name_of_company": "",
                  "rent_price": "",
                  "varai": "",
                  "maintenance": "",
                  "extra_amenities": "",
                  "other_charges": "",
                  "tenant_deposit_amount": "",
                  "register_address": "",
                  "required_area": "",
                  "constitution": "",
                  "pan_no": "",
                  "gst_no": "",
                  "country": "",
                  "state": "",
                  "city": "",
                  "pincode": "",
                  "status": "",
                });
                setEdit(false)
                setAvailCheck(false)
              }
            });
        } else {
          setBtndis(false);
        }
      } catch (err) {
        setBtndis(false);
        dispatch(loaderAction(false));
        console.log(err);
      }
    }
    setIsInvestorArrayDirty(false);
  };

  const draftHandeler = async (data) => {
    data.other_charges == '' ? data.other_charges = 0.0 : '';
    var status = data.status;
    data.investor = invesarr;
    data.project = userProject;
    if (data.required_area === "" || data.required_area == 0) {
      data.required_area = 0.0;
    }
    if (data.rent_price === "") {
      data.rent_price = 0.0;
    }
    if (data.varai === "") {
      data.varai = 0.0;
    }
    if (data.extra_amenities === "") {
      data.extra_amenities = 0.0;
    }
    if (data.maintenance === "") {
      data.maintenance = 0.0;
    }
    if (data.city === "") {
      data.city = "city"
    }
    if (data.company_email === "") {
      data.company_email = "company_email"
    }
    if (data.country === "") {
      data.country = "country"
    }
    if (data.state === "") {
      data.state = "state"
    }
    if (data.pincode === "") {
      data.pincode = 0
    }
    if (data.contact_number === "") {
      data.contact_number = "contact_number"
    }
    if (data.register_address === "") {
      data.register_address = "register_address"
    }
    if (data.tenant_deposit_amount === "") {
      data.tenant_deposit_amount = 0.0
    }

    data.rent_sqft = Number(data.rent_price) + Number(data.varai) + Number(data.maintenance) + Number(data.extra_amenities) + Number(data.other_charges)


    dispatch(loaderAction(true))
    try {
      await axios.put(`${environment.baseUrl}edit-temp-proposal/${ID}`, data).then((form) => {
        if (form.data.code === 200) {
          dispatch(successModalToggle());
          setCreate(false);
          setinvesarr([]);
          setProposalInvestors();
          setBtndis(true);
          dispatch(loaderAction(false));
          // getProposals();
          filterApiCall();
          reset();
          autoCancel();
        } else {
          setBtndis(false);
        }
      })
    } catch (err) {
      dispatch(loaderAction(false))
      console.log(err);
      setBtndis(false);
    }
    // setOpen(true)
    setBtndis(false);
  }

  const cancelButton = () => {
    if (isDirty || isInvestorArrayDirty) {
      setFormDataLossToggle(true)
      dispatch(warningModalToggle())
    } else {
      autoCancel()
    }
  }

  const autoCancel = () => {
    cancelButtonLogic();
  }

  const onCancelPressed = () => {
    cancelButtonLogic();
    dispatch(warningModalToggle())
    setIsInvestorArrayDirty(false)
  }

  const cancelButtonLogic = (id) => {
    setCreate(false);
    reset({
      "building_no": "",
      "name_of_company": "",
      "rent_price": "",
      "varai": "",
      "maintenance": "",
      "extra_amenities": "",
      "other_charges": "",
      "tenant_deposit_amount": "",
      "register_address": "",
      "required_area": "",
      "constitution": "",
      "pan_no": "",
      "gst_no": "",
      "country": "",
      "state": "",
      "city": "",
      "pincode": "",
      "additional_comments": "",
    });
    setEdit(false);
    setBtndis(false);
    setTotalArea(0);
    setProposalInvestors();
    setinvesarr([]);
    setAvailCheck(false);
    setArea([]);
    setFormDataLossToggle(false)
    setIsInvestorArrayDirty(false)
  }

  const deleteProposalData = (id) => {
    dispatch(warningModalToggle(id));
  };

  const deleteData = (id) => {
    dispatch(loaderAction(true))
    dispatch(warningModalToggle(id))
    axios.delete(`${environment.baseUrl}edit-temp-proposal/${id}`).then(res => {
      if (res.data.code === 200) {
        dispatch(loaderAction(false))
        dispatch(successModalToggle())
        // getProposals()
        filterApiCall();
      }
    })
      .catch(res => {
        dispatch(loaderAction(false))
        console.log("error");
      })
  };

  const editForm = async (data) => {
    if (data.project.id) {
      setCreate(true);
      setID(data.id);
      // setEdit(true);
      setTotalArea(0);
      await getInvestors(data.project.id, data.building_no.id);
      if (data.building_no.id) {
        let total = 0
        aray.map((investor) => {
          total = Number(total) + Number(investor.sold_gala_area)
        })
        setArea(round(total, 2));
      }
      reset({
        "building_no": data.building_no.id,
        "name_of_company": data.name_of_company,
        "company_email": data.company_email === "company_email" ? "" : data.company_email,
        "contact_number": data.contact_number,
        "rent_price": data.rent_price === "0.00" ? "" : data.rent_price,
        "varai": data.varai === "0.00" ? "" : data.varai,
        "maintenance": data.maintenance === "0.00" ? "" : data.maintenance,
        "extra_amenities": data.extra_amenities === "0.00" ? "" : data.extra_amenities,
        "other_charges": data.other_charges === "0.00" ? "" : data.other_charges,
        "tenant_deposit_amount": data.tenant_deposit_amount === "0.00" ? "" : data.tenant_deposit_amount,
        "register_address": data.register_address === "register_address" ? "" : data.register_address,
        "required_area": data.required_area === "0.00" ? "" : data.required_area,
        "constitution": data.constitution.id,
        "pan_no": data.pan_no,
        "gst_no": data.gst_no,
        "country": data.country === "country" ? "" : data.country,
        "state": data.state === "state" ? "" : data.state,
        "pincode": data.pincode === 0 ? "" : data.pincode,
        "status": data.status,
        "city": data.city === "city" ? "" : data.city,
        "lessor_name": data.lessor_name,
        "lessor_address": data.lessor_address,
        "facility_location": data.facility_location,
        "type_of_structure": data.type_of_structure,
        "building_type": data.building_type.id,
        "building_size": data.building_size,
        "total_carpet_area": data.total_carpet_area,
        "rentalsqft": data.rentalsqft,
        "taxes": data.taxes,
        "refundable_security": data.refundable_security,
        "tenure": data.tenure,
        "lock_in_period": data.lock_in_period,
        "notice_period": data.notice_period,
        "stamp_duty": data.stamp_duty,
        "payment_terms": data.payment_terms,
        "licenses_approval": data.licenses_approval,
        "escalation_maintenance": data.escalation_maintenance,
        "possession_date": data.possession_date,
        "parking_area": data.parking_area,
        "water_connection": data.water_connection,
        "electricity_charges": data.electricity_charges,
        "representation_lessor": data.representation_lessor,
        "check_inclusive": data.check_inclusive,
        "additional_comments": data.additional_comments,
        "additional_comments1": data.additional_comments1,
        "additional_comments2": data.additional_comments2,
        "additional_comments3": data.additional_comments3,
      });
      if (data?.contact_number != "contact_number")
        setContactNumber(data.contact_number)
    }
  }

  const handleArea = (e, row) => {
    invesarr.map((data) => {
      if (data.id == row.id) {
        let total = totalArea
        let available = row.sold_gala_area - row.rent_area - row.resell_area
        if (data.required_area != available) {
          total = total - data.required_area
          data.required_area = Number(e.target.value)
          total = total + data.required_area
        } else {
          total = total - Number(available)
          data.required_area = Number(e.target.value)
          total = total + data.required_area
        }
        setTotalArea(total)
      }
    })
  }

  const getAll = (event) => {
    if (event.target.checked == true) {
      const updatedInvestors = investors.map(investor => ({
        ...investor,
        check: true
      }));
      setInvestors(updatedInvestors);
      let tot = 0
      investors.map(data => {
        if(Number(data.sold_gala_area - data.rent_area - data.resell_area).toFixed(2) != 0) {
          invesarr.push({ "id": data.id, "required_area": data.sold_gala_area - data.rent_area, "check": true, "avail": (data.sold_gala_area) - (data.rent_area) - (data.resell_area) });
          tot = Number(tot) + Number(data.sold_gala_area - data.rent_area - data.resell_area)
        }
      })
      setTotalArea(tot)

      var myNodeList = document.getElementsByClassName("selectInv");
      for (let i = 0; i < myNodeList.length; i++) {
        myNodeList[i].checked = true;
      }

    } else {
      const updatedInvestors = investors.map(investor => ({
        ...investor,
        check: false
      }));
      setInvestors(updatedInvestors);
      setinvesarr([])
      setTotalArea(0)
    }
  }

  const handleArray = (event, data) => {
    setIsInvestorArrayDirty(true)
    let flag = false
    invesarr.map(arr => {
      if (arr.id == data.id) {
        flag = true
      }
    })
    if (flag == false) {
      if (data.required_area == undefined) {
        data.required_area = data.sold_gala_area - data.rent_area - data.resell_area
        data.check = true
      }
      if (event?.target?.checked == true) {
        invesarr.push({ "id": data.id, "required_area": data.required_area, "check": data.check, "avail": (data.sold_gala_area) - (data.rent_area) - (data.resell_area) });
        setTotalArea(totalArea + (data.sold_gala_area - data.rent_area - data.resell_area))
      }
      else if (event.target.checked == false) {
        let currentlength = invesarr.length;
        for (let i = 0; i < currentlength; i++) {
          if (data?.id == invesarr[i]?.id) {
            if (invesarr[i].avail != invesarr[i].required_area) {
              setTotalArea(totalArea - invesarr[i].required_area)
              invesarr[i].required_area = 0
            } else {
              setTotalArea(totalArea - (data.sold_gala_area - data.rent_area - data.resell_area))
            }
            invesarr.splice(i, 1)
          }
        }
      }
    } else {
      let currentlength = invesarr.length;
      for (let i = 0; i < currentlength; i++) {
        if (data?.id == invesarr[i]?.id) {
          if (invesarr[i].avail != invesarr[i].required_area) {
            setTotalArea(totalArea - invesarr[i].required_area)
            invesarr[i].required_area = 0
          } else {
            setTotalArea(totalArea - (data.sold_gala_area - data.rent_area - data.resell_area))
          }
          invesarr.splice(i, 1)
        }
      }
    }
  }

  const Age = (date_of_completion) => {
    const currentDate = moment(new Date()).format('YYYY-MM-DD');
    const CompleteDate = moment(date_of_completion).format('YYYY-MM-DD')
    var date1 = moment(currentDate);
    var date2 = moment(CompleteDate);
    let days = date1.diff(date2, 'days');
    date2.add(days, 'days')
    return days
  }
  const handleToggle = () => {
    setLetterToggle(!letterToggle)
  }

  useMemo(() => {
    if (totalArea?.toFixed(2) > Number(requiredarea)) {
      setTotalerr("Investors Area is greater than the area required by the Company,Please add area manually");
      setBtndis(true)
    }else if (totalArea?.toFixed(2) < Number(requiredarea)) {
      setTotalerr("Investors Area is smaller than the area required by the Company,Please add area carefully");
      setBtndis(true)
    } else {
      setBtndis(false)
      setTotalerr()
    }
  }, [totalArea, requiredarea])

  const handleEditArea = (e, data) => {
    let flag = 0
    let index = -1
    invesarr.map((obj) => {
      if (obj.id == data.id) {
        index = flag
      }
      flag = flag + 1
    })
    if (index >= 0) {
      invesarr[index].required_area = e.target.value
    } else {
      invesarr.push({ "id": data.id, "required_area": e.target.value })
    }
  }
  const handelDiable = (row) => {
    let flag = false
    invesarr?.forEach(data => {
      if (data?.id == row?.id || (row.sold_gala_area - row.rent_area - row.resell_area) == 0 || row.check == false)
        flag = true;
    })
    return !flag
  }

  const handelPlaceholder = (row) => {
    let flag = 0
    invesarr?.forEach(data => {
      if (data?.id == row?.id) {
        flag = data?.required_area;
      }
    })
    return Number(flag).toFixed(2)
  }

  const handleError = (e, row) => {
    setIsInvestorArrayDirty(true);
    if (e.target.value > row.sold_gala_area - row.rent_area) {
      setErr("Required Area is greater than Available Area")
      setBtndis(true)
    } else {
      setErr("")
      setBtndis(false)
    }
  }

  const column = [
    {
      name: 'Investor',
      selector: row => row?.Investors?.name,
      sortable: true,
      wrap: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Building No',
      selector: row => row.building.building_no,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Gala No',
      selector: row => Number(row.gala.gala_no),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Sub Gala Name',
      selector: row => row.sub_gala_name,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Area Owns',
      selector: row => (Number(row.sold_gala_area).toFixed(2)) + " " + "Sq.ft",
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Available Area',
      selector: row => (Number(row.sold_gala_area - row.rent_area - row.resell_area).toFixed(2)) + " " + "Sq.ft",
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Select Investors',
      cell: (row) => <div className="d-flex justify-content-between align-items-center gap-2 " >
        <input
          type="checkbox"
          id="invarr"
          checked={invesarr.some(data => data.id == row.id)}
          disabled={(row.sold_gala_area - row.rent_area - row.resell_area) == 0}
          className='checkinclusive selectInv'
          onChange={(e) => { handleArray(e, row) }}>
        </input>
      </div>,
    },
    {
      name: 'Required Area',
      selector: row => {
        return <>
          <div className='mt-1  d-flex gap-3'>
            <div className="numberTextSuffix w-100">
              <input
                className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                type='number'
                name={`area_${row.id}`}
                min={0}
                step="any"
                // disabled={handelDiable(row?.id)||(row.sold_gala_area - row.rent_area - row.resell_area) == 0 || row.check == false || row.check == undefined}
                disabled={handelDiable(row)}
                onKeyDown={preventNegativeValues}
                minLength={0}
                // value={tempDraftInvestor.some(data => data.investor.id == row.id)? Number(tempDraftInvestor.required_area):0}
                placeholder={handelPlaceholder(row)}
                onBlur={(e) => { handleArea(e, row) }}
                onChange={(e) => { handleError(e, row) }}
              />
            </div>
          </div>
        </>
      },
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    }
  ];

  const columnnn = [
    {
      name: 'Investor',
      selector: row => row?.investor.Investors?.name,
      sortable: true,
      wrap: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Gala No',
      selector: row => Number(row.investor.gala.gala_no),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Sub Gala Name',
      selector: row => row.investor.sub_gala_name,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Area Owns',
      selector: row => (row.investor.sold_gala_area) + " " + "Sq.ft",
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Available Area',
      selector: row => {
        if (((row.investor.sold_gala_area - row.investor.rent_area) < row.required_area)) {
          setAvailCheck(true)
        }
        return row.investor.sold_gala_area - row.investor.rent_area - row.investor.resell_area + " " + "Sq.ft";
      },
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Required Area',
      selector: row => {
        return <>
          <div className='mt-1  d-flex gap-3'>
            {
              edit ? <>
                <div className="mt-1  d-flex gap-3">
                  <label className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-700 fs-2 modal-input bg-white form-label">{row.required_area} Sq.ft</label></div>
              </> :
                <div className="numberTextSuffix w-100">
                  <input
                    className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                    type='number'
                    step="any"
                    name={`area_${row.id}`}
                    placeholder={`${row.investor.sold_gala_area - row.investor.rent_area}`}
                    minLength={0}
                    onBlur={(e) => { handleEditArea(e, row) }}
                  />
                </div>
            }
          </div>
          {errors.Required_Area && <ErrorComponents error={'Required Area is required *'} />}
        </>
      },
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
  ];

  const columns = [
    {
      name: 'LOI Id',
      selector: row => row.id,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Company Name',
      selector: row => row.name_of_company,
      wrap: true,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Building Name',
      selector: row => row.building_no?.building_no,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Required Area',
      selector: row => (Number(row.required_area).toFixed(2)) + " " + "Sq.ft",
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    // {
    //   name: 'Status',
    //   selector: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
    //     <label className={`${row.status === 'Approved' && 'icon-bg-green icon-color-green '} ${row.status === 'Pending' && 'icon-bg-yellow icon-color-yellow'} ${row.status === 'Denied' && 'icon-bg-red icon-color-red'}   rounded-pill status-box rounded fs-4`}>{row.status}</label>
    //   </div>,
    //   sortable: true,
    //   style: {
    //     fontSize: "2.3rem",
    //   }
    // },
    {
      name: 'Date',
      selector: row => moment(row.created_at).format('DD/MM/YYYY'),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Age(days)',
      selector: row => Age(row.created_at) + " " + "(days)",
      sortable: true,
      style: {
        fontSize: "2.3rem",
        textAlign: "center"
      }
    },
    {
      name: 'Action',
      cell: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
        {user?.role != 'user' && <>
          <button onClick={() => { getDraftProposalInvestors(row.id) }} className="icon-bg-yellow border-0 px-2 py-3 rounded"><PencilLine size="28" className='icon-color-yellow' /></button>
          {
            user?.role == 'superadmin' && <button className="icon-bg-red border-0 px-2 py-3 rounded" onClick={() => deleteProposalData(row.id)}><Trash size="28" className='icon-color-red' /></button>
          }</>}
      </div>,
    },
  ];

  useMemo(() => {
    if (userProject) {
      var projectBuilding = buildingList?.filter(
        (filterBuilding) => filterBuilding.project.id == userProject
      );
      setFilterBuilding(projectBuilding);
    }
  }, [userProject]);

  useEffect(() => {
    if (filterBuilding == undefined && userProject != undefined) {
      getBuildingData();
    }
  }, [userProject])

  useEffect(() => {
    if (filterBuilding == undefined && userProject != undefined) {
      getBuildingData();
    }
  }, [userProject])

  const getBuildingData = () => {
    try {
      axios.get(`${environment.baseUrl}building/`).then(res => {
        dispatch(getBuildingAction(res.data));
        if (userProject) {
          var projectBuilding = res.data?.filter(
            (filterBuilding) => filterBuilding.project.id == userProject
          );
          setFilterBuilding(projectBuilding);
        }
      }).catch(res => {
        console.log("error");
      })
    }
    catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    setValue("rentalsqft", `Rs -(Rupees) per sq. ft. per month on the Built up area bifurcating as /- (All Inclusive) per month will be paid to the Lessor by the lessee from the date of possession of the scheduled property subject to physical measurement.`)
    // getProposals();
    getTenant();
    getBuildingType()
  }, [userProject])

  useEffect(() => {
    setInvestors(investors)
  }, [investors])

  const proposalstatus = (e) => {
    if (e.target.value !== "") {
      const proposalFilter = proposalStatus?.filter((curElem, i) => {
        return (
          curElem.status.toLowerCase() === e.target.value.toLowerCase()
        )
      })
      setProposal(proposalFilter)
    } else {
      setProposal(proposalStatus)
    }

  }

  const getBuildingType = () => {
    dispatch(loaderAction())
    try {
      axios
        .get(`${environment.baseUrl}building-type/`)
        .then((res) => {
          setBuildingType(res.data);
          dispatch(loaderAction())
        })
        .catch((res) => {
          dispatch(loaderAction())
          console.log("error");
        });
    }
    catch (err) {
      dispatch(loaderAction())
      console.log(err);
    }
  };

  useMemo(() => {
    if (totalPrice && requiredarea) {
      let total = totalPrice * requiredarea
      if (intentdata?.rentalsqft == undefined) {
        setValue("rentalsqft", `Rs ${totalPrice}/-(Rupees) per sq. ft. per month on the Built up area bifurcating as ${total}/- (All Inclusive) per month will be paid to the Lessor by the lessee from the date of possession of the scheduled property subject to physical measurement.`)
      } else {
        setValue('rentalsqft', `${intentdata?.rentalsqft.split('-')[0]}${totalPrice}/- ${intentdata?.rentalsqft.split('-')[1].split('as')[0]}as ${total}${intentdata?.rentalsqft.split('-')[1].split('as')[1]}- ${intentdata?.rentalsqft.split('-')[2]}`)
      }
    }
    if (selbuilding) {
      var building = buildingList.filter(
        (filterBuilding) => filterBuilding.id == selbuilding
      );
      setValue("building_type", building[0]?.building_type.id)
      setValue("building_size", building[0]?.area_builtup)
      setValue("total_carpet_area", building[0]?.area_carpet)
      setValue("water_connection", building[0]?.water_supply)
    }

  }, [totalPrice, selbuilding, requiredarea])


  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isDirty || isInvestorArrayDirty) {
        console.log("lol me")
        let text = "You have unsaved changes. Are you sure you want to leave?";
        if (confirm(text) == true) {
          text = "You pressed OK!";
        } else {
          console.log("You canceled!");
          e.preventDefault();
        }
      }
    };

    window.addEventListener('urlchangeevent', handleBeforeUnload);
    return () => {
      window.removeEventListener('urlchangeevent', handleBeforeUnload);
    };
  }, [isDirty, isInvestorArrayDirty]);

  const filterApiCall = (localPage = undefined, localRecords = undefined) => {
    if(userProject != undefined){
      let url = ""
      if(localPage == undefined && localRecords == undefined){
        if(pageNo != 1){
          setPageNo(1);
        }
        url = `${environment.baseUrl}temp-proposal-paginated-filter/?project=${userProject}&p=1&records=${records}`;
      }else if(localPage != undefined){
        url = `${environment.baseUrl}temp-proposal-paginated-filter/?project=${userProject}&p=${localPage}&records=${records}`;
      }else if(localRecords != undefined){
        url = `${environment.baseUrl}temp-proposal-paginated-filter/?project=${userProject}&p=1&records=${localRecords}`;
      }
      axios.get(url).then((res) => {
        if(res?.data?.next != null && nextIsValid != true){
          setNextIsValid(true)
        }else if(res?.data?.next == null && nextIsValid != false){
          setNextIsValid(false)
        }
        if(res?.data?.previous != null && prevIsValid != true){
          setPrevIsValid(true)
        }else if(res?.data?.previous == null && prevIsValid != false){
          setPrevIsValid(false)
        }
  
        if(res?.data?.results.length > 0){
          setProposal(res.data.results)
        }else{
          setProposal([])
        }
      }).catch((err) => {
        console.log(err);
        toast.error('Something went wrong', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
        });
      })
    }
  }

  useEffect(()=> {
    if(userProject != undefined){
      filterApiCall()
    }
  },[userProject])

  const pageChangeHandler = (LocalPageNo) => {
    if(((pageNo < LocalPageNo) && nextIsValid) || ((pageNo > LocalPageNo) && prevIsValid)){
      filterApiCall(LocalPageNo, undefined) // page change call
      setPageNo(LocalPageNo)
    }
  }

  const recordChangeHandler = (recordSize) => {
    filterApiCall(undefined, recordSize) // record change call
    setRecords(recordSize);
    setPageNo(1);
  }

  return (
    <>
      <SuccessPopups />
      <ErrorPopups open={open} message={"Please select investor"} />
      {!formDataLossToggle && <WarningPopup deleteData={deleteData} />}
      {formDataLossToggle && <WarningPopup deleteData={onCancelPressed} customMessage="You have unsaved changes." />}
      {createe && formForceRerender &&
        <>
          <button className="d-flex align-items-center border-0 bg-transparent pb-4" onClick={cancelButton}>
            <i className='bx bx-arrow-back fs-2 title-font-600 px-2 bx-fade-left'></i>
            <span className='fs-3 base-font-600'>Back</span> </button>
          <div className="bg-white rounded-5 mb-5 shadow-sm  p-4 p-md-4 p-lg-5 p-xl-5">
            <div className="d-flex justify-content-between align-items-center">
              <h1 className='title-font-bold pb-3 mb-0'>DRAFTED LOI</h1>
            </div>
            <div >
              <div className=' pb-1'>
                <Form onSubmit={handleSubmit(AddProposal)}>
                  <div className="row">
                    {/* <div className='col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1'>
                      <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                        Select Project Name
                      </Label>
                      <br />
                      <div className="mt-1  d-flex gap-3">
                        <select
                          id="project"
                          name="project"
                          className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                          {...register("project", { required: true })}
                        >
                          <option value="">Select Project</option>
                          {projectList?.map((project, i) => {
                            return <option value={project.id} key={i}>{project.name}</option>;
                          })}
                        </select>
                      </div>
                      {errors.project && (
                        <ErrorComponents error={"Project name is required *"} />
                      )}
                      <br />
                    </div> */}
                    <div className='col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1'>
                      <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                        Select Building *
                      </Label>
                      <br />
                      <div className='mt-1  d-flex gap-3'>
                        <select id="building_no" name="building_no" className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                          {...register("building_no", { required: true, onChange: restData })}
                        >
                          <option value="">Select Building</option>
                          {filterBuilding?.map((building, i) => {
                            return <option value={building.id} key={i}>{building.building_no}</option>
                          })

                          }
                        </select>
                      </div>
                      {errors.building_no && <ErrorComponents error={'Building No is required *'} />}
                      <br />
                    </div>
                    <div className='col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1'>
                      <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                        Company Name *
                      </Label>
                      <br />
                      <div className='mt-1  d-flex gap-3'>
                        <input
                          className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-700 fs-2 modal-input'
                          type='text'
                          minLength={0}
                          placeholder='Enter Company Name...'
                          {...register("name_of_company", { required: true })}
                        />
                      </div>

                      {errors.name_of_company && <ErrorComponents error={'Company Name is required *'} />}
                      <br />
                    </div>
                    <div className='col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1'>
                      <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                        Select Constitution *
                      </Label>
                      <br />
                      <div className='mt-1  d-flex gap-3'>
                        <select id="constitution" name="constitution" className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                          {...register("constitution", { required: true })}
                        >
                          <option value="">Select Constitution</option>
                          {constitutionlist?.map((constitution, i) => {
                            return <option value={constitution.id} key={i}>{constitution.constitution}</option>
                          })

                          }
                        </select>
                      </div>
                      {errors.constitution && <ErrorComponents error={'Constitution is required *'} />}
                      <br />
                    </div>
                    <div className='col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1'>
                      <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                        Company Email *
                      </Label>
                      <br />
                      <div className='mt-1  d-flex gap-3'>
                        <input
                          className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                          type='email'
                          placeholder='Enter Company email...'
                          {...register("company_email", { required: true })}
                        />
                      </div>

                      {errors.company_email && <ErrorComponents error={'Company Email is required *'} />}
                      <br />
                    </div>
                    <div className='col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1'>
                      <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                        Company Contact
                      </Label>
                      <br />
                      <div className='mt-1  d-flex gap-3'>
                        <Phone {...register('contact_number')} defaultCountry="in" value={contactNumber} className='d-flex border-radius-10 shadow-none px-4  w-100 fs-4 title-font-500 fs-2 modal-input bg-white py-3'>
                          <Phone.Country className='fs-4 border-0 w-25 border-end' />
                          <Phone.Number placeholder="1234567890" className=' ps-2 w-75 fs-4 title-font-500  border-0' />
                        </Phone>
                      </div>
                      {errors.contact_number && <ErrorComponents error={'Enter valid contact'} />}
                      <br />
                    </div>

                    <div className='col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1'>
                      <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                        Register Address *
                      </Label>
                      <br />
                      <div className='mt-1  d-flex gap-3'>
                        <input
                          className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                          type='text'
                          minLength={0}
                          placeholder='Enter Register Address...'
                          {...register("register_address", { required: true })}
                        />
                      </div>
                      {errors.register_address && <ErrorComponents error={'Register Address is required *'} />}
                      <br />
                    </div>
                    <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
                      <Label className="fs-4 title-font-500 mb-0 text-base-color">
                        City Name *
                      </Label>
                      <br />
                      <div className="mt-1  d-flex gap-3">
                        <input
                          className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                          type='text'
                          minLength={0}
                          placeholder='Enter City...'
                          {...register("city", { required: true })}
                        />
                      </div>
                      {errors.city && (
                        <ErrorComponents error={"City name is required *"} />
                      )}
                    </div>

                    <div className='col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1'>
                      <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                        State *
                      </Label>
                      <br />
                      <div className='mt-1  d-flex gap-3'>
                        <input
                          className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                          type='text'
                          minLength={0}
                          placeholder='Enter State...'
                          {...register("state", { required: true })}
                        />
                      </div>
                      {errors.state && <ErrorComponents error={'State is required *'} />}
                      <br />
                    </div>
                    <div className='col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1'>
                      <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                        Country *
                      </Label>
                      <br />
                      <div className='mt-1  d-flex gap-3'>
                        <input
                          className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                          type='text'
                          minLength={0}
                          placeholder='Enter Country...'
                          {...register("country", { required: true })}
                        />
                      </div>
                      {errors.country && <ErrorComponents error={'Country is required *'} />}
                      <br />
                    </div>
                    <div className='col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1'>
                      <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                        Pin Code *
                      </Label>
                      <br />
                      <div className='mt-1  d-flex gap-3'>
                        <input
                          className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                          type='number'
                          min={0}
                          onKeyDown={preventNegativeValues}
                          placeholder='Enter Pin Code ...'
                          {...register("pincode", { required: true, onChange: (e) => { debounce(e.target.value) } })}
                        />
                      </div>
                      {errors.pincode && <ErrorComponents error={'Pin Code is required *'} />}
                      {pinerror && <ErrorComponents error={pinerror} />}
                      <br />
                    </div>
                    {
                      area.length != 0 &&
                      <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                        <Label className="fs-4 title-font-500 mb-0 text-base-color">Available Area</Label>
                        <div className="mt-1  d-flex gap-3">
                          <Label className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-700 fs-2 modal-input bg-white" placeholder='Availabel Area..'>
                            {area} Sqft
                          </Label>
                        </div>
                        {
                          area.length != 0 &&
                          <Label className="fs-5 title-font-700 mb-0 text-base-black">
                            {toWords.convert(area)}
                          </Label>
                        }
                      </div>
                    }

                    <div className='col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1'>
                      <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                        Required Area *
                      </Label>
                      <br />
                      <div className='mt-1  d-flex gap-3'>
                        <div className="numberTextSuffix w-100">
                          <input
                            className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                            type='number'
                            min={0}
                            step="any"
                            onKeyDown={preventNegativeValues}
                            placeholder='Enter Required Area...'
                            {...register("required_area", { required: true })}
                          />
                        </div>
                      </div>
                      {
                        requiredarea &&
                        <>
                          <small className="fs-2 title-font-600 text-left"><span className="text-black">{toWords.convert(Number(Number(requiredarea)?.toFixed(2)))}</span></small>
                          <br />
                        </>
                      }
                      {carpeterror && <ErrorComponents error={carpeterror} />}
                      {errors.required_area && <ErrorComponents error={'Area is required *'} />}
                      {errors.required_area && <ErrorComponents error={errors.required_area.message ? errors.required_area.message : clearErrors()} />}
                      <br />
                    </div>

                    <div className='col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1'>
                      <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                        Pan Number
                      </Label>
                      <br />
                      <div className='mt-1  d-flex gap-3'>
                        <input
                          className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input text-uppercase'
                          type='text'
                          minLength={0}
                          maxLength={10}
                          onKeyDown={preventNegativeValuesspi}
                          placeholder='Enter Pan Number...'
                          {...register("pan_no", {
                            pattern: {
                              value: /^([A-Z]{5})(\d{4})([A-Z])$/,
                              message: "Enter valid Pan No"
                            }
                            , onChange: (e) => { e.target.value = e.target.value.toUpperCase() }
                          })}
                        />
                      </div>
                      <br />
                    </div>
                    <div className='col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1'>
                      <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                        GST Number
                      </Label>
                      <br />
                      <div className='mt-1  d-flex gap-3'>
                        <input
                          className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input text-uppercase'
                          type='text'
                          minLength={0}
                          onKeyDown={preventNegativeValuesspi}
                          maxLength={15}
                          placeholder='Enter GST Number...'
                          {...register("gst_no", { onChange: (e) => { e.target.value = e.target.value.toUpperCase() }, onBlur: (e) => { checkGst(e.target.value) } })}
                        />
                      </div>
                      <br />
                      {panerror && (
                        <ErrorComponents error={panerror} />
                      )}
                    </div>

                    <div className='col-11 mx-auto col-md-4 col-lg-4 col-xl-4 pb-3 pt-1  mx-md-0'>
                      <Label className='fs-4 title-font-500 mb-0 text-base-color form-label'>
                        Rent Price *
                      </Label>
                      <br />
                      <div className='mt-1 d-flex gap-3'>
                        <div className="numberTextSuffixPrice w-100">
                          <input
                            className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                            type='number'
                            min={0}
                            onKeyDown={preventNegativeValues}
                            step="any"
                            placeholder='Enter Rent Price...'
                            {...register("rent_price", { required: true })}
                          />
                        </div>
                      </div>
                      {errors.rent_price && <ErrorComponents error={'Rent Price required*'} />}
                      <br />
                    </div>
                    <div className='col-11 mx-auto col-md-4 col-lg-4 col-xl-4 pb-3 pt-1  mx-md-0'>
                      <Label className='fs-4 title-font-500 mb-0 text-base-color form-label'>
                        Varai
                      </Label>
                      <br />
                      <div className='mt-1 d-flex gap-3'>
                        <div className="numberTextSuffixPrice w-100">
                          <input
                            className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                            type='number'
                            min={0}
                            onKeyDown={preventNegativeValues}
                            step="any"
                            placeholder='Enter Varai...'
                            {...register("varai", { required: false })}
                          />
                        </div>
                      </div>
                      {errors.varai && <ErrorComponents error={'Varai is required *'} />}
                      <br />
                    </div>
                    <div className='col-11 mx-auto col-md-4 col-lg-4 col-xl-4 pb-3 pt-1  mx-md-0'>
                      <Label className='fs-4 title-font-500 mb-0 text-base-color form-label'>
                        Maintenance
                      </Label>
                      <br />
                      <div className='mt-1 d-flex gap-3'>
                        <div className="numberTextSuffixPrice w-100">
                          <input
                            className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                            type='number'
                            min={0}
                            onKeyDown={preventNegativeValues}
                            step="any"
                            placeholder='Enter Maintenance ...'
                            {...register("maintenance", { required: false })}
                          />
                        </div>
                      </div>
                      {errors.maintenance && <ErrorComponents error={'Maintenance is required *'} />}
                      <br />
                    </div>
                    <div className='col-11 mx-auto col-md-4 col-lg-4 col-xl-4 pb-3 pt-1  mx-md-0'>
                      <Label className='fs-4 title-font-500 mb-0 text-base-color form-label'>
                        Extra Amenities
                      </Label>
                      <br />
                      <div className='mt-1 d-flex gap-3'>
                        <div className="numberTextSuffixPrice w-100">
                          <input
                            className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                            type='number'
                            min={0}
                            onKeyDown={preventNegativeValues}
                            step="any"
                            placeholder='Enter Extra Amenities ...'
                            {...register("extra_amenities", { required: false })}
                          />
                        </div>
                      </div>
                      {errors.extra_amenities && <ErrorComponents error={'Extra Amenities is required *'} />}
                      <br />
                    </div>
                    <div className='col-11 mx-auto col-md-4 col-lg-4 col-xl-4 pb-3 pt-1  mx-md-0'>
                      <Label className='fs-4 title-font-500 mb-0 text-base-color form-label'>
                        Other Charges
                      </Label>
                      <br />
                      <div className='mt-1 d-flex gap-3'>
                        <div className="numberTextSuffixPrice w-100">
                          <input
                            className='p-3  border-radius-10 shadow-none w-100 fs-4 title-font-500 fs-2 modal-input '
                            type='number'
                            min={0}
                            onKeyDown={preventNegativeValues}
                            step="any"
                            placeholder='Enter Other Charges...'
                            {...register("other_charges", { required: false, onBlur: () => handleToggle() })}
                          />
                        </div>
                      </div>
                      {errors.other_charges && <ErrorComponents error={'Other Charges is required *'} />}
                      <br />
                    </div>
                    <div className='col-11 mx-auto col-md-4 col-lg-4 col-xl-4 pb-3 pt-1  mx-md-0'>
                      <Label className='fs-4 title-font-500 mb-0 text-base-color form-label'>
                      Tenant Deposit
                      </Label>
                      <br />
                      <div className='mt-1 d-flex gap-3'>
                        <div className="w-100">
                          <input
                            className='p-3  border-radius-10 shadow-none w-100 fs-4 title-font-500 fs-2 modal-input '
                            type='text'
                            placeholder='Tenant Deposit Amount...'
                            {...register("tenant_deposit_amount", { required: false, pattern: {
                              value: /^[0-9.]+$/,
                              message: 'Invalid Amount',
                            }, onBlur: () => handleToggle() })}
                          />
                        </div>
                      </div>
                      {errors.tenant_deposit_amount && <ErrorComponents error={errors.tenant_deposit_amount.message} />}
                      <br />
                    </div>
                    <div className='col-11 mx-auto col-md-4 col-lg-4 col-xl-4 pb-3 pt-1  mx-md-0'>
                      <Label className='fs-4 title-font-500 mb-0 opacity-0 form-label'>
                        .
                      </Label>
                      <div className="d-flex align-items-center pt-4 ">
                        <input type="checkbox" name="checkinclusive" id="checkinclusive" className='checkinclusive'  {...register("check_inclusive")} />
                        <label htmlFor="checkinclusive" className='fs-4 ps-2 title-font-500 text-base-color'>Please Check To All Inclusive !</label>
                      </div>
                      {errors.other_charges && <ErrorComponents error={'Other Charges is required *'} />}
                      <br />
                    </div>
                    {edit &&
                      <div className='col-11 mx-auto col-md-4 col-lg-4 col-xl-4 pb-3 pt-1  mx-md-0'>
                        <Label className='fs-4 title-font-500 mb-0 text-base-color form-label'>
                          Status
                        </Label>
                        <br />
                        <div className='mt-1 d-flex gap-3 '>
                          <select id="status" name="status" className="p-3  border-radius-10 shadow-none   w-100 fs-3 title-font-700 fs-2 border-red-colorr"
                            {...register("status", { required: true })}
                          >
                            <option value="">Select Status</option>
                            <option value="Pending">Pending </option>
                            <option value="Approved">Approve</option>
                            <option value="Denied">Deny</option>
                          </select>
                        </div>
                        {errors.other_charges && <ErrorComponents error={'Other Charges is required *'} />}
                        <br />
                      </div>
                    }

                    {
                      totalPrice > 0 &&
                      <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0 "><label className="fs-5 title-font-700 mb-0 text-base-black form-label opacity-0">.</label>
                        <div className="mt-1  d-flex gap-3"><label placeholder="" className="p-3  border-radius-10 shadow-none  w-50 fs-3 title-font-700 fs-2 modal-input text-black  border-base-color-2 form-label">{<PriceFormater price={totalPrice} />}</label></div></div>
                    }
                    {
                      totalPrice != 0 &&
                      <>
                        <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-5 pt-1  mx-md-0 "></div>
                      </>
                    }
                    <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-5 pt-1  mx-md-0 "><label className="fs-5 title-font-700 mb-0 text-base-black form-label opacity-0">.</label>
                      <div className="mt-1  d-flex gap-3 justify-content-center">
                        <Button className='border-radius-7 p-3 d-flex align-items-center buttons' onClick={() => { setLetterToggle(!letterToggle) }}><span className='fs-3 d-flex gap-3 title-font-600 px-3'>Letter Of Intent</span></Button>
                      </div></div>
                    {
                      letterToggle &&
                      <>
                        <hr className='border-base-color-2' />
                        <h1 className="fs-1 title-font-700 text-base-color py-3">Letter Of Intent</h1>
                        <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
                          <Label className="fs-4 title-font-500 mb-0 text-base-color">
                            Name
                          </Label>
                          <br />
                          <div className="mt-1  d-flex gap-3">
                            <input
                              className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                              type="text"
                              placeholder="Enter Name..."
                              {...register("lessor_name", { required: true })}
                            />
                          </div>
                          {errors.lessor_name && <ErrorComponents error={errors.name?.message} />}
                          <br />
                        </div>
                        <div className='col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1'>
                          <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                            Address of the Lessor
                          </Label>
                          <br />
                          <div className='mt-1  d-flex gap-3'>
                            <textarea
                              rows={4}

                              className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                              placeholder='Enter Address...'
                              {...register("lessor_address", { required: true })}
                            ></textarea>
                          </div>
                          {errors.lessor_address && <ErrorComponents error={' POC Comments is required *'} />}
                          <br />
                        </div>
                        <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
                          <Label className="fs-4 title-font-500 mb-0 text-base-color">
                            Location of the Facility
                          </Label>
                          <br />
                          <div className="mt-1  d-flex gap-3">
                            <textarea
                              rows={4}

                              className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                              placeholder='Enter Address...'
                              {...register("facility_location", { required: true })}
                            ></textarea>
                          </div>
                          {errors.facility_location && (
                            <ErrorComponents error={errors.country?.message} />
                          )}
                          <br />
                        </div>
                        <div className='col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1'>
                          <Label className='fs-4 title-font-500 mb-0 text-base-color'>
                            Construct Type
                          </Label>
                          <br />
                          <div className='mt-1  d-flex gap-3'>
                            <select id="constitution" disabled name="constitution" className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                              placeholder="Type of Structure..."
                              {...register("building_type", { required: true })}
                            >
                              <option value="">Select Type of Building</option>
                              {buildingtype?.map((type, i) => {
                                return <option value={type.id} key={i}>{type.name}</option>;
                              })}
                            </select>
                          </div>
                          {errors.building_type && (
                            <ErrorComponents error={errors.state?.message} />
                          )}
                          <br />
                        </div>
                        <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
                          <Label className="fs-4 title-font-500 mb-0 text-base-color">
                            Building Size
                          </Label>
                          <br />
                          <div className="mt-1  d-flex gap-3">
                            <div className="numberTextSuffix w-100">
                              <input
                                className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                type="number"
                                disabled
                                min={0}
                                placeholder="Shed Size here..."
                                {...register("building_size", { required: true })}
                              />
                            </div>
                          </div>
                          {errors.building_size && (
                            <ErrorComponents error={"Shed Size is required *"} />
                          )}
                          <br />
                        </div>
                        <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
                          <Label className="fs-4 title-font-500 mb-0 text-base-color">
                            Total Carpet Area
                          </Label>
                          <br />
                          <div className="mt-1  d-flex gap-3">
                            <div className="numberTextSuffix w-100">
                              <input
                                className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                type="number"
                                disabled
                                placeholder="Total Carpet Area..."
                                {...register("total_carpet_area", { required: true })}
                              />
                            </div>
                          </div>
                          {errors.total_carpet_area && (
                            <ErrorComponents error={"Total Carpet Area is required *"} />
                          )}
                          <br />
                        </div>
                        <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
                          <Label className="fs-4 title-font-500 mb-0 text-base-color">
                            Rent and Other charges
                          </Label>
                          <br />
                          <div className="mt-1  d-flex gap-3">
                            <textarea
                              rows={4}
                              className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                              placeholder='Enter Rent and Other charges'
                              {...register("rentalsqft", { required: true })}
                            ></textarea>
                          </div>
                          {errors.rentalsqft && (
                            <ErrorComponents error={"Rent and Other charges is required *"} />
                          )}
                          <br />
                        </div>
                        <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
                          <Label className="fs-4 title-font-500 mb-0 text-base-color">
                            Taxes
                          </Label>
                          <br />
                          <div className="mt-1  d-flex gap-3">
                            <textarea
                              rows={4}

                              className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                              placeholder='Enter Taxes...'
                              {...register("taxes", { required: true })}
                            ></textarea>
                          </div>
                          {errors.taxes && (
                            <ErrorComponents error={"Taxes is required *"} />
                          )}
                          <br />
                        </div>

                        <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
                          <Label className="fs-4 title-font-500 mb-0 text-base-color">
                            Refundable Security Deposit
                          </Label>
                          <br />
                          <div className="mt-1  d-flex gap-3">
                            <textarea
                              rows={4}

                              className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                              placeholder='Enter Refundable Security Deposit...'
                              {...register("refundable_security", { required: true })}
                            ></textarea>
                          </div>
                          {errors.refundable_security && (
                            <ErrorComponents
                              error={"Refundable Security Deposit  is required *"}
                            />
                          )}
                          <br />
                        </div>
                        <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
                          <Label className="fs-4 title-font-500 mb-0 text-base-color">
                            Tenure
                          </Label>
                          <br />
                          <div className="mt-1  d-flex gap-3">
                            <input
                              className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                              type="text"
                              placeholder="Tenure"
                              {...register("tenure", { required: true })}
                            />
                          </div>
                          {errors.tenure && (
                            <ErrorComponents
                              error={"Tenure  is required *"}
                            />
                          )}
                          <br />
                        </div>
                        <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
                          <Label className="fs-4 title-font-500 mb-0 text-base-color">
                            Lock In Period
                          </Label>
                          <br />
                          <div className="mt-1  d-flex gap-3">
                            <input
                              className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                              type="text"
                              placeholder="Lock In Period"
                              {...register("lock_in_period", { required: true })}
                            />
                          </div>
                          {errors.lock_in_period && (
                            <ErrorComponents
                              error={"Lock In Period  is required *"}
                            />
                          )}
                          <br />
                        </div>
                        <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
                          <Label className="fs-4 title-font-500 mb-0 text-base-color">
                            Notice Period
                          </Label>
                          <br />
                          <div className="mt-1  d-flex gap-3">
                            <input
                              className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                              type="text"
                              placeholder="Notice Period"
                              {...register("notice_period", { required: true })}
                            />
                          </div>
                          {errors.notice_period && (
                            <ErrorComponents
                              error={"Notice Period  is required *"}
                            />
                          )}
                          <br />
                        </div>
                        <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
                          <Label className="fs-4 title-font-500 mb-0 text-base-color">
                            Stamp Duty
                          </Label>
                          <br />
                          <div className="mt-1  d-flex gap-3">
                            <textarea
                              rows={4}

                              className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                              placeholder="Stamp Duty"
                              {...register("stamp_duty", { required: true })}
                            ></textarea>
                          </div>
                          {errors.stamp_duty && (
                            <ErrorComponents
                              error={"Stamp Duty  is required *"}
                            />
                          )}
                          <br />
                        </div>
                        <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
                          <Label className="fs-4 title-font-500 mb-0 text-base-color">
                            Payment Terms
                          </Label>
                          <br />
                          <div className="mt-1  d-flex gap-3">
                            <textarea
                              rows={4}

                              className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                              placeholder="Refundable Security Deposit"
                              {...register("payment_terms", { required: true })}
                            ></textarea>
                          </div>
                          {errors.payment_terms && (
                            <ErrorComponents
                              error={"Payment Terms  is required *"}
                            />
                          )}
                          <br />
                        </div>
                        <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
                          <Label className="fs-4 title-font-500 mb-0 text-base-color">
                            Type of Permission
                          </Label>
                          <br />
                          <div className="mt-1  d-flex gap-3">
                            <textarea
                              rows={4}

                              className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                              placeholder="Type of Permission"
                              {...register("licenses_approval", { required: true })}
                            ></textarea>
                          </div>
                          {errors.licenses_approval && (
                            <ErrorComponents
                              error={"Type of Permission  is required *"}
                            />
                          )}
                          <br />
                        </div>
                        <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
                          <Label className="fs-4 title-font-500 mb-0 text-base-color">
                            Increment in Rent & Maintenance
                          </Label>
                          <br />
                          <div className="mt-1  d-flex gap-3">
                            <input
                              className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                              type="text"
                              placeholder="Increment in Rent & Maintenance"
                              {...register("escalation_maintenance", { required: true })}
                            />
                          </div>
                          {errors.escalation_maintenance && (
                            <ErrorComponents
                              error={" Increment in Rent & Maintenance  is required *"}
                            />
                          )}
                          <br />
                        </div>
                        <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
                          <Label className="fs-4 title-font-500 mb-0 text-base-color">
                            Date of Possession
                          </Label>
                          <br />
                          <div className="mt-1  d-flex gap-3">
                            <input
                              className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                              type="date"
                              placeholder="Date of Possession "
                              {...register("possession_date", { required: true })}
                            />
                          </div>
                          {errors.possession_date && (
                            <ErrorComponents
                              error={"Date of Possession  Deposit  is required *"}
                            />
                          )}
                          <br />
                        </div>
                        <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
                          <Label className="fs-4 title-font-500 mb-0 text-base-color">
                            Parking
                          </Label>
                          <br />
                          <div className="mt-1  d-flex gap-3">
                            <input
                              className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                              type="text"
                              step="any"
                              placeholder="Parking"
                              {...register("parking_area", { required: true })}
                            />
                          </div>
                          {errors.parking_area && (
                            <ErrorComponents
                              error={"Parking  is required *"}
                            />
                          )}
                          {/* {
                            parkingarea != undefined &&
                            <>
                              <small className="fs-2 title-font-600 text-left"><span className="text-black">{toWords.convert(parkingarea)}</span></small>
                              <br />
                            </>
                          } */}
                          <br />
                        </div>
                        <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0">
                          <Label className="fs-4 title-font-500 mb-0 text-base-color">
                            Water Supply
                          </Label>
                          <br />
                          <div className="mt-1  d-flex gap-3">
                            <select
                              id="water_supply"
                              name="role_type"
                              disabled
                              className="p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                              {...register("water_connection", { required: true })}
                            >
                              <option value="">Select Water Supply</option>
                              {watersupply?.map((water, i) => {
                                return (
                                  <option value={water.water_supply} key={i}>{water.water_supply}</option>
                                );
                              })}
                            </select>
                          </div>
                          {errors.water_supply && (
                            <ErrorComponents error={"Water Supply is required *"} />
                          )}
                          <br />
                        </div>
                        <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
                          <Label className="fs-4 title-font-500 mb-0 text-base-color">
                            Electricity
                          </Label>
                          <br />
                          <div className="mt-1  d-flex gap-3">
                            <textarea
                              rows={4}

                              className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                              placeholder="Electricity"
                              {...register("electricity_charges", { required: true })}
                            ></textarea>
                          </div>
                          {errors.electricity_charges && (
                            <ErrorComponents
                              error={"Electricity  is required *"}
                            />
                          )}
                          <br />
                        </div>
                        <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
                          <Label className="fs-4 title-font-500 mb-0 text-base-color">
                            Additional Comments
                          </Label>
                          <br />
                          <div className="mt-1  d-flex gap-3">
                            <textarea
                              rows={4}

                              className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                              placeholder="Additional Comments"
                              {...register("additional_comments")}
                            ></textarea>
                          </div>
                          <br />
                        </div>
                        <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
                          <Label className="fs-4 title-font-500 mb-0 text-base-color">
                            Additional Comments 1
                          </Label>
                          <br />
                          <div className="mt-1  d-flex gap-3">
                            <textarea
                              rows={4}

                              className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                              placeholder="Additional Comments 1"
                              {...register("additional_comments1")}
                            ></textarea>
                          </div>
                          <br />
                        </div>
                        <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
                          <Label className="fs-4 title-font-500 mb-0 text-base-color">
                            Additional Comments 2
                          </Label>
                          <br />
                          <div className="mt-1  d-flex gap-3">
                            <textarea
                              rows={4}

                              className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                              placeholder="Additional Comments 2"
                              {...register("additional_comments2")}
                            ></textarea>
                          </div>
                          <br />
                        </div>
                        <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
                          <Label className="fs-4 title-font-500 mb-0 text-base-color">
                            Additional Comments 3
                          </Label>
                          <br />
                          <div className="mt-1  d-flex gap-3">
                            <textarea
                              rows={4}

                              className='p-3  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input'
                              placeholder="Additional Comments 3"
                              {...register("additional_comments3")}
                            ></textarea>
                          </div>
                          <br />
                        </div>
                        <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1"></div>
                        <div className="col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1">
                          <div className="d-flex align-items-center pt-5 position-relative top-50 justify-content-center gap-3">
                            <input type="checkbox" name="check_verify" id="check_verify" className='checkinclusive'  {...register("check_verify", { onChange: (e) => { setVerify(e.target.checked) } })} />
                            <label htmlFor="check_verify" className='fs-3 title-font-700  text-base-color'>{!edit ? "Please Verify LOI First" : "Please Verify LOI Again"}</label>
                          </div>
                        </div>
                      </>
                    }
                    <p className='fs-2'>{availCheck == true && <ErrorComponents error={"Gala area is not available, Can't approve LOI"} />}</p>
                    {investors?.length > 0 && <div className="col-12 mx-auto pb-3 pt-3 ">
                      {selbuilding && formForceRerender &&
                        <div>
                          <div className="d-flex align-items-center gap-5">
                            <h1 className="mb-4 title-font-bold ">INVESTORS</h1>
                            <div className="d-flex align-items-center gap-4 mb-4">
                              {!edit && <>
                                <input type='checkbox' className='checkinclusive' onChange={(e) => { getAll(e) }} />
                                <label className="fs-2 title-font-700  text-base-black"> Select All
                                </label>
                              </>}
                            </div>

                          </div>
                          <Table columns={edit ? columnnn : column} data={edit ? proposalinvestors : investors} />
                          {err && <ErrorComponents error={err} />}
                          {totalerr && <ErrorComponents error={totalerr} />}
                        </div>}
                    </div>}
                  </div>
                  <div className='col-12 mx-auto d-flex justify-content-between gap-4'>
                    <div className="d-flex w-100">
                      {
                        requiredarea > 0 && <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0 ">
                          <div className="mt-1  d-flex gap-3"><label placeholder="" className="p-3  border-radius-10 shadow-none  w-75 fs-3 title-font-700 fs-2 modal-input text-black text-nowrap  border-base-color-2 form-label">{Number(requiredarea)?.toFixed(2)} Sq.ft</label></div>
                          <label className="fs-5 title-font-700 mb-0 text-base-black form-label">{toWords.convert(Number(Number(requiredarea)?.toFixed(2)))}</label></div>
                      }

                      {totalArea && <div className="col-11 mx-auto col-md-6 col-lg-4 col-xl-4  pb-3 pt-1  mx-md-0 ">
                        <div className="mt-1  d-flex gap-3"></div><label placeholder="" className="p-3  border-radius-10 shadow-none   title-font-700 fs-3 modal-input text-white bg-base-color border-0 form-label text-nowrap">Total Area : {totalArea?.toFixed(2)} Sq.fts</label> <br />
                        <label className="fs-5 title-font-700 mb-0 text-base-black form-label">{toWords.convert(Number(Number(totalArea).toFixed(2)))}</label>
                      </div>}
                    </div>

                    <div className="d-flex align-items-center gap-5">
                      {
                        verify == false && <div className="text-nowrap pt-4"><ErrorComponents error={"Please Verify LOI First in letter of intent"} /></div>

                      }

                      <div className="">
                        <Label className='fs-4 title-font-500 mb-0 opacity-0 form-label'>
                        </Label>
                        <Button className='border-radius-7 p-3 d-flex align-items-center buttons' disabled={btndis || verify != true || carpeterror}> <span className="fs-4 d-flex gap-3 title-font-600 px-4">
                          {edit
                            ? "Save"
                            : `Create`}
                        </span></Button>
                      </div>
                      <div className="">
                        <Button className='border-radius-7 p-3 d-flex align-items-center' onClick={() => (draftHandeler(getValues()))}><span className='fs-4 d-flex gap-3 title-font-600 px-3'>Draft</span></Button>
                      </div>
                      <div className="">
                        <Button className='border-radius-7 p-3 d-flex align-items-center' onClick={cancelButton}><span className='fs-4 d-flex gap-3 title-font-600 px-3'>Cancel</span></Button>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </>
      }
      {
        !createe &&
        <>
          <div className="bg-white p-4 p-md-4 p-lg-5 p-xl-5 d-flex gap-5 flex-column rounded-5 mt-1 mb-5">
            <div className="">
              <div className='d-flex justify-content-between align-items-center pb-5'>
                <h1 className='title-font-bold '>Draft LOI</h1>
                {/* <div className="d-flex align-items-center gap-5">
                  <div className="pb-3 pt-1">
                    <select
                      id="ProposalStatus"
                      name="Proposal_Status"
                      className="p-3 select-width  border-radius-10 shadow-none  fs-4 title-font-500 fs-2 modal-input"
                      {...register("proposal_status", { onChange: (e) => { proposalstatus(e) } })}
                    >
                      <option value="">Select Status</option>
                      <option value="Approved">Approved</option>
                      <option value="Pending">Pending</option>
                      <option value="Denied">Denied</option>
                    </select>
                  </div>
                  <div className="">
                    <Button className='border-radius-7 text-nowrap p-4 d-flex align-items-center buttons' onClick={() => { setCreate(true) }}><span className='fs-3 d-flex gap-3 title-font-600 px-3'>Create LOI</span></Button>
                  </div>
                </div> */}

              </div>
              {proposal?.[0] != undefined ? <><Table columns={columns} data={proposal} pageinationProp={true}/> 
              <div className="d-flex align-items-center justify-content-between gap-md-5 gap-lg-5 gap-xl-5  flex-column flex-md-row flex-lg-row flex-xl-row">
                    <div className="pb-3 pt-1 pb-md-5 pb-lg-5 pb-xl-5">
                      {""}
                    </div>
                    <div className='d-flex mr-2 gap-3 align-items-center justify-content-between'>
                      <select
                          className="mt-4 p-3 select-width-data-table-wo-pagination title-font-500 fs-2"
                          defaultValue={"10"}
                          {...register("recordSize", { onChange: (e) => { recordChangeHandler(e.target.value) } })}
                        >
                          <option value="8">8</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                        
                      </select>
                      <span onClick={() => {pageChangeHandler(pageNo-1)}} className="fs-3 d-flex gap-3 title-font-600 ps-2 pe-1 mt-4"><ArrowSquareLeft color='#6271de' size="28" variant="Bold"/></span>
                      <span onClick={() => {pageChangeHandler(pageNo+1)}} className="fs-3 d-flex gap-3 title-font-600 ps-2 pe-2 mt-4"><ArrowSquareRight color='#6271de' size="28" variant="Bold"/></span>
                    </div>
                </div>
              </>


              : <EmptyTable />}
            </div>
            <Docm />
          </div>
        </>
      }

    </>
  )
}

export default DraftedProposal